export const stockfishAssetUrls = {
  worker: "/stockfish/stockfish-18-lite-single.js",
  wasm: "/stockfish/stockfish-18-lite-single.wasm",
} as const;

export const stockfishEngineName = "Stockfish 18 Lite";
